import { Button, Card, Form, Input, Typography } from "antd";

import { useState } from "react";
import { useDispatch } from "react-redux";
import { customerForgetPassword } from "../../redux/rtk/features/user/userSlice";
import SuccessPage from "./Page/SuccessPage";
import logo from "../../assets/images/resqroom-dark-logo.png"
const CustomerForgetPass = () => {
  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();
  const { Title } = Typography;

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const resp = await dispatch(customerForgetPassword(values));
      setLoader(true);
      if (resp.payload.message === "success") {
        setLoader(false);
        setSuccess(true);
      } else {
        setLoader(false);
      }

      form.resetFields();
    } catch (error) {
      console.log(error.message);
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoader(false);
    console.log("Failed:", errorInfo);
  };

  return (
    <div
      className='flex justify-center items-center h-[85vh] lg:h-screen mt-[-16px] bg-[#F2F2F2] lg:ms-[-240px] rounded-lg'
    >
      {success ? (
        <SuccessPage />
      ) : (
        <div className="w-full flex flex-col justify-center items-center">
          <img src={logo} className="mb-4 h-12 w-auto"/>
          <div className='w-full lg:w-1/3 bg-white'>
            <Card bordered={false} className='rounded-lg'>
              <Title level={3} className=' text-start'>
                Recover Password
              </Title>
              <p className='text-start mb-6'>
                Enter your email for recover your password
              </p>
              <Form
                form={form}
                className=''
                name='basic'
                wrapperCol={{
                  span: 24,
                }}
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete='off'
              >
                <Form.Item
                  className='mb-8  text-start form-item-alignment username'
                  label='Username'
                  name='userName'
                  rules={[
                    {
                      required: true,
                      message: "Please input your userName!",
                    },
                  ]}
                >
                  <Input placeholder="Enter Username or Email" className="username-field h-[40px] bg-[#f9fafb] rounded-[0.7rem]" />
                </Form.Item>  

                <Form.Item style={{ marginBottom: "10px" }} className='mb-2'>
                  <Button
                    onClick={() => setLoader(true)}
                    type="primary"
                    block
                    htmlType='submit'
                    shape='round'
                    loading={loader}
                    className="h-[40px] font-[600] rounded-[0.75rem] bg-[#E5383B] text-white"
                  >
                    Recover Password
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerForgetPass;
